export const theme = {
  colors: {
    sakura: '#FFB7C5',    // Light pink
    matcha: '#88B04B',    // Soft green
    indigo: '#284B63',    // Deep blue
    washi: '#F7F7F7',     // Off-white
    sumi: '#424242',      // Charcoal
    overlay: 'rgba(0, 0, 0, 0.5)',
    bubble: {
      user: '#2b5876',
      agent: '#1a472a',
      system: '#444444',
    }
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },
  breakpoints: {
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px',
  },
  transitions: {
    fast: '0.2s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  zIndex: {
    background: 0,
    character: 1,
    chat: 2,
    navigation: 3,
    modal: 4,
  }
} as const; 